import { render, staticRenderFns } from "./CaseInformation.vue?vue&type=template&id=18196548&scoped=true&"
import script from "./CaseInformation.vue?vue&type=script&lang=js&"
export * from "./CaseInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18196548",
  null
  
)

export default component.exports